import { Brick, registerBrick, ErrorFlow } from 'olympe';
import { getLogger } from '@olympeio/core';
import * as _ from 'lodash';
import { getAsJson, iterateInObject } from '../../helper';

export default class OmitBy extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {*} predicate
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    async update($, [source, predicate], [setResult, setErrorFlow]) {
        const logger = getLogger('Omit By');

        // Guards
        if (!(predicate instanceof Brick)) {
            logger.error('Provided predicate input is not a Brick');
            return;
        }

        const { json, error } = getAsJson(source);

        if (!error) {
            const lambdaResults = await iterateInObject($, json, predicate);

            let index = 0;
            const result = _.omitBy(json, () => lambdaResults[index++]);
            setResult(result);
        } else {
            logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error.message, error.code));
        }
    }
}

registerBrick('017ff9fb45ec574d2879', OmitBy);